import * as React from 'react';
import {
    List,
    Datagrid,
    DateField,
    FunctionField,
    TextField,
    TextInput,
} from 'react-admin';

const filters = [
    <TextInput key="q" label="Recherche" source="q" alwaysOn resettable />,
];

export default function ContactMessageList(props) {
    return (
        <List
            {...props}
            filters={filters}
            sort={{ field: 'createdAt', order: 'DESC' }}
            perPage={25}
        >
            <Datagrid rowClick="show" bulkActionButtons={false}>
                <DateField source="createdAt" label="Reçu le" showTime />
                <TextField source="email" label="Expéditeur" />
                <TextField source="reason" label="Motif" />
                <FunctionField
                    label="Message"
                    render={(record) => {
                        if (!record?.message) return '';
                        return record.message.length > 120
                            ? `${record.message.slice(0, 120)}…`
                            : record.message;
                    }}
                />
            </Datagrid>
        </List>
    );
}
